import { useState, useEffect } from "react";
import { useQuery } from "@apollo/react-hooks";
import { GetDashboardInfo } from "./queries";
import { endOfDate } from "../../helpers/DateManipulation";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { useChecklist } from "../../molecules/Checklist/hooks";

export default function useDashboardReport() {
  const history = useHistory();

  const [filters, setFilters] = useState({
    date: [
      moment()
        .subtract(3, "months")
        .toDate(),
      new Date()
    ]
  });

  const welcomeMessage = {
    NonProfit:
      "This message will be replaced with the message for user type Non Profit",
    Political:
      "This message will be replaced with the message for user type Political"
  };

  const { loading, data, error } = useQuery(GetDashboardInfo, {
    variables: {
      date: {
        greaterThanOrEqual: filters.date[0].toUTCString(),
        lessThanOrEqual: endOfDate(filters.date[1]).toUTCString()
      }
    }
  });

  const { showChecklist } = useChecklist(data && data.accounts[0].type);

  const filterOptions = [
    {
      key: "date",
      label: "Date Range",
      type: "dateRange",
      required: true
    }
  ];

  const totalVideos =
    data && data.reports && data.reports.overviewReport.totalVideos;
  const totalViews =
    data && data.reports && data.reports.overviewReport.totalViews;
  const totalSales =
    data && data.reports && data.reports.overviewReport.completedPurchases;
  const totalSalesAmount =
    data && data.reports && data.reports.overviewReport.totalSalesAmount;
  const influencerReport =
    data && data.reports && data.reports.influencerReport;

  const accountType = data && data.accounts && data.accounts[0].type;
  const isNmiAccount = data && data.accounts && data.accounts[0].isNmiAccount;
  const hasSales = data && data.accounts && data.accounts[0].hasSales;
  const subscription = data && data.accounts && data.accounts[0].subscription;

  return {
    loading,
    error,
    totalVideos,
    totalViews,
    totalSales,
    totalSalesAmount,
    filters,
    filterOptions,
    setFilters,
    influencerReport,
    accountType,
    hasSales,
    subscription,
    showChecklist,
    welcomeMessage,
    isNmiAccount
  };
}
